import { useButtonClasses } from "../Button/Button";
import styles from "./ButtonLink.module.css";
import Link from "next/link";
import { ReactNode } from "react";

interface Props {
  primary?: boolean;
  children: ReactNode;
  href: string;
}

export function ButtonLink(props: Props): React.ReactElement {
  const classNames = useButtonClasses(props) + " " + styles.button;

  return (
    <Link href={props.href} className={classNames} prefetch={false}>
      {props.children}
    </Link>
  );
}
